import BulkActionsDrawerItem from "components/BulkActions/Drawer/Item";
import BulkActionsDrawerItemLink from "components/BulkActions/Drawer/Item/Link";
import BulkActionsDrawerItemStatusIcon from "components/BulkActions/Drawer/Item/StatusIcon";
import BulkActionsDrawerItemStopExecutionButton from "components/BulkActions/Drawer/Item/StopExecutionButton";
import { BulkActionsResult, BulkActionsStep } from "components/BulkActions/types";
import RunStateBadge from "components/Run/elements/StateBadge";
import Box from "ds/components/Box";
import Feedback from "ds/components/Feedback";
import Link from "ds/components/Link";
import { FetchStackRunTaskData } from "shared/Stack/useTaskCreate/gql";

import { StacksBulkActionsResultsPollingItemProps } from "./Item";

const StacksBulkActionsResultsItemRunTask = ({
  stack,
  tab,
  resultsMetadata,
  status,
  stopExecution,
  polledState,
}: StacksBulkActionsResultsPollingItemProps) => {
  const feedbackVariant = status === BulkActionsResult.Failed ? "danger" : "info";
  const taskData = resultsMetadata?.data as FetchStackRunTaskData | undefined;
  const taskId = taskData?.taskCreate?.id;
  const taskState = polledState?.state ?? taskData?.taskCreate?.state;

  return (
    <BulkActionsDrawerItem key={stack.id} direction="column" align="start">
      <Box align="center" gap="medium" fullWidth zeroMinWidth>
        <BulkActionsDrawerItemStatusIcon result={status} />
        <BulkActionsDrawerItemLink
          link={`/stack/${stack.id}`}
          text={stack.name}
          step={BulkActionsStep.Results}
          itemCategory={tab}
        />
        <BulkActionsDrawerItemStopExecutionButton onStopExecution={stopExecution} status={status} />
      </Box>

      {taskId && (
        <Box gap="small" align="center">
          {taskState && <RunStateBadge state={taskState} />}
          <Link
            href={`/stack/${stack.id}/run/${taskId}`}
            size="small"
            variant="secondary"
            target="_blank"
          >
            View task
          </Link>
        </Box>
      )}

      {resultsMetadata?.message && (
        <Feedback type="banner" variant={feedbackVariant} fullWidth>
          {resultsMetadata.message}
        </Feedback>
      )}
    </BulkActionsDrawerItem>
  );
};

export default StacksBulkActionsResultsItemRunTask;
